import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { MAX_BREAKS_LENGTH_RULES } from 'modules/attendance/lib/utils/BreakSettings'

import RuleItem from './RuleItem'
import type RuleForm from './form'
import type DurationRuleForm from './form'

interface Props {
  durationRuleForms: RuleForm[]
  addRule: () => void
  deleteRule: (form: DurationRuleForm) => void
}

const DurationRules = ({ durationRuleForms, addRule, deleteRule }: Props) => {
  const maxRulesSize = MAX_BREAKS_LENGTH_RULES
  const validRules = durationRuleForms.filter((form) => !form.get('_destroy').value)
  const rulesSize = validRules.length

  const canAdd = (index: number) => {
    const isLast = index + 1 === rulesSize

    return isLast && rulesSize < maxRulesSize
  }

  const crypto = window.crypto || window.msCrypto
  const randomIds = new Uint32Array(1)
  const randomId = crypto.getRandomValues(randomIds)

  return (
    <Box gap="s12">
      {validRules.map((form, index) => (
        <RuleItem
          // Most forms don't have an id
          // so we use randomId instead to prevent React from reusing the same component
          key={`${index}_${randomId}_ ${form.get('id').value}`}
          form={form}
          onAdd={addRule}
          onDelete={deleteRule}
          canAdd={canAdd(index)}
          rulesSize={rulesSize}
        />
      ))}
    </Box>
  )
}

export default observer(DurationRules)
